// Picture Grid Work — GSAP fallback only when scroll-driven CSS isn't supported.
(function () {
  const sections = document.querySelectorAll('.sl-wrap');
  if (!sections.length) return;

  const hasScrollSupport =
    (CSS && CSS.supports && (
      CSS.supports('animation-timeline: scroll()') ||
      CSS.supports('view-timeline-name: --x') ||
      CSS.supports('animation-timeline: --x')
    ));

  const loadScript = (src) =>
    new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = src;
      s.defer = true;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });

  sections.forEach(async (section) => {
    if (section.dataset.enhanced !== 'true') return;
    if (hasScrollSupport) return; // native CSS handles it

    // Try local GSAP first (upload to Assets if needed)
    const localGSAP = window.Shopify && window.Shopify.routes
      ? `${Shopify.routes.root}assets/gsap.min.js`
      : null;
    const localST   = window.Shopify && window.Shopify.routes
      ? `${Shopify.routes.root}assets/ScrollTrigger.min.js`
      : null;

    try {
      if (localGSAP) await loadScript(localGSAP);
      if (!window.gsap) await loadScript('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js');

      if (localST) await loadScript(localST);
      if (!window.ScrollTrigger) await loadScript('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js');
    } catch(e) {
      return;
    }

    const gsap = window.gsap;
    gsap.registerPlugin(window.ScrollTrigger);

    const stage = section.querySelector('.sl-stage');
    const scalerImg = section.querySelector('.sl-scaler-img');
    const overlay   = section.querySelector('.sl-hero-overlay__inner');
    const layers = [
      section.querySelector('.sl-layer--1'),
      section.querySelector('.sl-layer--2'),
      section.querySelector('.sl-layer--3')
    ].filter(Boolean);

    // Hero: viewport -> cell size
    gsap.timeline({
      scrollTrigger: { trigger: stage, start: 'top -10%', end: 'bottom 80%', scrub: true }
    })
    .fromTo(
      scalerImg,
      { width: window.innerWidth - 2 * 16, height: window.innerHeight - 2 * 16 },
      { width: '100%', height: '100%', ease: 'power2.inOut' },
      0
    );

    // Overlay fade out
if (overlay){
  gsap.timeline({
    scrollTrigger: { trigger: stage, start: 'top -5%', end: 'bottom 70%', scrub: true }
  })
  .fromTo(overlay, { opacity: 1, y: 0 }, { opacity: 0, y: -10, ease: 'power1.inOut' }, 0);
}

    // Layers: fade + scale
    const tl = gsap.timeline({
      scrollTrigger: { trigger: stage, start: 'top -40%', end: 'bottom bottom', scrub: true }
    });

    layers.forEach((layer, i) => {
      tl.from(layer, { opacity: 0, ease: 'sine.out' }, 0)
        .from(layer, {
          scale: 0,
          transformOrigin: '50% 50%',
          ease: (['power1','power3','power4'][i] || 'power1') + '.inOut'
        }, 0);
    });
  });
})();